import { FUNNEL_STEPS, type InviteFunnel as InviteFunnelData } from "@/utils/inviteForecast";

/**
 * The eligibility funnel for the batch: everyone who ordered yesterday
 * (the batch's window), minus each exclusion bucket in owner words, ending at the number who
 * will actually be invited. Only shows a row for a bucket that excluded
 * someone, so a clean funnel stays short. Read-only display.
 */
export function InviteFunnel({ funnel }: { funnel: InviteFunnelData }) {
  const rows = FUNNEL_STEPS.filter((step) => funnel[step.key] > 0);

  return (
    <dl className="space-y-1.5 text-sm">
      <div className="flex items-baseline justify-between gap-3">
        <dt className="text-muted-foreground">Ordered yesterday</dt>
        <dd className="font-semibold tabular-nums text-foreground">{funnel.ordered_in_window}</dd>
      </div>
      {rows.map((step) => (
        <div key={step.key} className="flex items-baseline justify-between gap-3">
          <dt className="text-muted-foreground">
            <span aria-hidden="true" className="mr-1 text-muted-foreground/60">
              &minus;
            </span>
            {step.label}
          </dt>
          <dd className="tabular-nums text-muted-foreground">
            <span className="sr-only">minus </span>
            {funnel[step.key]}
          </dd>
        </div>
      ))}
      <div className="flex items-baseline justify-between gap-3 border-t border-border pt-1.5">
        <dt className="font-medium text-foreground">Will be invited</dt>
        <dd className="text-lg font-bold tabular-nums text-status-success">{funnel.will_invite}</dd>
      </div>
    </dl>
  );
}
